module.exports = __webpack_public_path__ + "static/img/MX.2439110.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/countries/MX.png
// module id = ozqs
// module chunks = 17